/* eslint-disable */
export const apiURL = import.meta.env.VITE_API_URL;
export const websiteURL = import.meta.env.VITE_WEBSITE_URL;
export const loginURL = import.meta.env.VITE_LOGIN_URL;
export const mixPanelKey = import.meta.env.VITE_MIXPANEL_TOKEN;
export const therapyRoomURL = import.meta.env.VITE_THERAPYROOM_URL;
export const scullyURL = import.meta.env.VITE_SCULLY_URL;
export const bugsnagKey = import.meta.env.VITE_BUGSNAG_KEY;
export const fullScheduleURL = import.meta.env.VITE_ADMIN_URL;
export const pwaURL = import.meta.env.VITE_PWA_URL;

export const firebaseConfig = {
  apiKey: import.meta.env.VITE_FIREBASE_API_KEY,
  authDomain: import.meta.env.VITE_FIREBASE_AUTH_DOMAIN,
  databaseURL: import.meta.env.VITE_FIREBASE_DATABASE_URL,
  projectId: import.meta.env.VITE_FIREBASE_PROJECT_ID,
  storageBucket: import.meta.env.VITE_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: import.meta.env.VITE_FIREBASE_MESSAGING_SENDER_ID,
};

export const pusherKey = import.meta.env.VITE_PUSHER_KEY;
export const pusherCluster = import.meta.env.VITE_PUSHER_CLUSTER;
export const centrifugoUrl = import.meta.env.VITE_CENTRIFUGO_SOCKET_URL;

export const TYPE_PSYCHIATRIST = "psychiatrist";
export const TYPE_THERAPIST = "therapist";
export const TYPE_COUPLE_THERAPIST = "couple_therapist";
export const CF_INTAKE_PROVIDER = "cf-intake-specialist";
export const CF_PROVIDER_ROLE = [CF_INTAKE_PROVIDER, "cf-clinician"];
export const TYPE_CARE_COORDINATOR = "care_coordinator";

export const RISK_MANAGER_FEATURE_FLAG = "twa_private_risk_manager";

export const FETCH_STATUS = Object.freeze({
  IDLE: "idle",
  LOADING: "loading",
  SUCCESS: "success",
  ERROR: "error",
});

export const providerLabels = {
  therapist: "therapist",
  psychiatrist: "psychiatrist",
  couple_therapist: "couples therapist",
  assessments: "assessment admin",
  ancillary_assessment: "assessment admin",
  care_coordinator: "care coordinator",
};

export const defaultAvatarURL =
  "//assets.theinnerhour.com/profilepics/avatar.jpg";

export const googleCalendarUrl = "https://www.googleapis.com/calendar/v3";

// regex
export const isHtmlRegex = /<\/?[a-z][\s\S]*>/i;

export const phoneRegex = /^[6-9]\d{9}$/;

export const courses = [
  "sleep",
  "stress",
  "depression",
  "worry",
  "anger",
  "happiness",
];

export const userProgress = [
  {
    id: 1,
    label: "No Notable Change",
    value: "No Notable Change",
  },
  {
    id: 2,
    label: "Slight Progress",
    value: "Slight Progress",
  },
  {
    id: 3,
    label: "Some Progress Apparent",
    value: "Some Progress Apparent",
  },
  {
    id: 4,
    label: "Fluctuating/Intermittent Progress",
    value: "Fluctuating/Intermittent Progress",
  },
  {
    id: 5,
    label: "Significant Progress",
    value: "Significant Progress",
  },
  {
    id: 6,
    label: "Significant Improvement",
    value: "Significant Improvement",
  },
  {
    id: 7,
    label: "Maintaining Past Gains/Stable",
    value: "Maintaining Past Gains/Stable",
  },
  {
    id: 8,
    label: "Near Completion of Treatment",
    value: "Near Completion of Treatment",
  },
  {
    id: 9,
    label: "Current focus on maintenance/relapse prevention",
    value: "Current focus on maintenance/relapse prevention",
  },
  {
    id: 10,
    label: "Some increase in symptoms",
    value: "Some increase in symptoms",
  },
  {
    id: 11,
    label: "Significant escalation of symptoms",
    value: "Significant escalation of symptoms",
  },
];

export const symptomGraphSlugs = {
  "sleep-hygiene": "Poor Hygiene",
  thoughts: "Negative Thoughts",
  "stimulus-control-and-sleep-restriction": "Sleep Restriction",
  relaxation: "Relaxation",
  mindfulness: "Mindfulness",
  "attention-training": "Lack of Focus",
  "problem-solving": "Poor Problem Solving",
  assertiveness: "Communication Problems",
  "thought-balancing": "Negative Thoughts",
  "balancing-work-and-life": "Poor Work-Life Balance",
  health: "Poor Health",
  "understanding-anger": "Poor Understanding",
  "self-calming": "Poor Self-Calming",
  "overcoming-rumination": "Rumination",
  communication: "Communication Problems",
  "thought-work": "Balanced Thinking",
  "low-enjoyment": "Low Interest",
  "low-energy": "Fatigue",
  "lack-of-concentration": "Lack of Focus",
  "low-self-esteem": "Low Self-esteem",
  "negative-thoughts": "Negative Thoughts",
  anxiety: "Anxiety",
  "managing-worry": "Excessive Worry",
  "tolerating-uncertainty": "Low Tolerance",
  "focus-and-attention": "Lack of Focus",
  "problem-solving-and-overcoming-avoidance": "Poor Problem Solving",
  "sleeping-well": "Poor Sleep",
  gratitude: "Gratitude",
  "social-skills": "Social Support",
  "self-esteem": "Self-Competence",
  "physical-activity": "Physical Activity",
};

export const assessmentScoring = (score, course, ver) => {
  const version = parseFloat(ver.substring(1));
  let level = "";
  if (version === 3) {
    switch (course) {
      case "depression":
        return score <= 12
          ? "Mild depressive concerns"
          : score > 12 && score < 28
            ? "Moderate depressive concerns"
            : "Significant depressive concerns";

      case "stress":
        level =
          score <= 14 ? "Low" : score > 14 && score < 30 ? "Moderate" : "High";
        return `${level} levels of Stress`;

      case "worry":
        level =
          score <= 14 ? "Low" : score > 14 && score < 30 ? "Moderate" : "High";
        return `${level} levels of Anxiety`;

      case "sleep":
        return score <= 11
          ? "Mild sleep concerns"
          : score > 11 && score < 25
            ? "Moderate sleep concerns"
            : "Significant sleep concerns";

      case "anger":
        level =
          score <= 14 ? "Low" : score > 14 && score < 30 ? "Moderate" : "High";
        return `${level} levels of Anger`;

      case "happiness":
        level =
          score <= 14 ? "Low" : score > 14 && score < 30 ? "Moderate" : "High";
        return `${level} levels of Happiness`;

      default:
        return "";
    }
  } else if (version < 3) {
    switch (course) {
      case "depression":
        return score <= 16
          ? "Mild depressive concerns"
          : score > 16 && score < 36
            ? "Moderate depressive concerns"
            : "Significant depressive concerns";

      case "stress":
        level =
          score <= 14 ? "Low" : score > 14 && score < 30 ? "Moderate" : "High";
        return `${level} levels of Stress`;

      case "worry":
        level =
          score <= 16 ? "Low" : score > 16 && score < 36 ? "Moderate" : "High";
        return `${level} levels of Anxiety`;

      case "sleep":
        return score <= 16
          ? "Mild sleep concerns"
          : score > 16 && score < 36
            ? "Moderate sleep concerns"
            : "Significant sleep concerns";

      case "anger":
        level =
          score <= 12 ? "Low" : score > 12 && score < 28 ? "Moderate" : "High";
        return `${level} levels of Anger`;

      case "happiness":
        level =
          score <= 16 ? "Low" : score > 16 && score < 36 ? "Moderate" : "High";
        return `${level} levels of Happiness`;

      default:
        return "";
    }
  }
};

export const PRO_SKU_LIST = [
  "com.theinnerhour.innerhour.promonthly",
  "com.theinnerhour.innerhour.proquarterly",
  "com.theinnerhour.innerhour.proannually",
  "ip_pro_monthly_cred",
  "ip_pro_monthly",
  "ip_pro_quarterly",
  "ip_pro_quarterly_40discount_1session",
  "ip_pro_monthly_in",
  "ip_pro_quarterly_in",
  "ip_pro_quarterly_40discount_promo_in",
];

// action cable config
export const websocketApi = import.meta.env.VITE_WEBSOCKET_URL;
export const channel = "TwaNotificationsChannel";
export const bookingChannel = "BookingJoiningNotificationChannel";
export const notificationsUnreadCountChannel =
  "TwaNotificationsUnreadCountChannel";
export const batchStatusChannel = "TwaBatchActionChannel";

export const allowedFileTypes = [
  "application/zip", // .zip
  "application/x-7z-compressed", // .7z
  "application/vnd.rar", // .rar
  "application/pdf", // .pdf
  "application/vnd.ms-powerpoint", // .ppt
  "application/vnd.openxmlformats-officedocument.presentationml.presentation", // .pptx
  "application/vnd.ms-excel", // .xls
  "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet", // .xlsx
  "audio/mpeg", // .mp3
  "video/mp4", // .mp4
  "audio/x-m4a", // .m4a
  "audio/wav", // .wav
  "video/quicktime", // .mov
  "video/webm", // .webm
  "text/plain", // .txt
  "application/msword", // .doc
  "application/vnd.openxmlformats-officedocument.wordprocessingml.document", // .docx
  "image/png", // .png
  "image/jpg", // .jpg
  "image/jpeg", // .jpeg
  "image/bmp", // .bmp
];

export const ASSESSMENT = "psychometric_assessment";
export const GROUPTHERAPY = "group_therapy";

// PDF page dimensions
export const PAGE_WIDTH = 793.8;
export const PAGE_HEIGHT = 1122.6;

export const currencySymbols = {
  INR: "₹",
  USD: "$",
};

export const indianTimezones = ["Asia/Kolkata", "Asia/Calcutta"];
